import { createBrowserRouter, Navigate } from 'react-router'
import { AppShell } from './components/app-shell'
import { FullPageSpinner } from './components/ui/spinner'
import { RequireAuth } from './lib/auth'
import { LoginPage, ResetPasswordPage, SignupPage } from './pages/auth'
import { NotFoundPage, RouteErrorPage } from './pages/errors'
import { InvitePage } from './pages/invite'
import { ImportPage } from './pages/import'
import { RecordingPage } from './pages/recording'
import { RecordingsPage } from './pages/recordings'
import { StudioPage } from './pages/studio'
import { StudiosPage } from './pages/studios'
import { TeamPage } from './pages/team'

/** The studio room and the editor pull in LiveKit, MediaPipe and Yjs; they load only when opened. */
export const router = createBrowserRouter([
  {
    errorElement: <RouteErrorPage />,
    hydrateFallbackElement: <FullPageSpinner />,
    children: [
      { path: '/login', element: <LoginPage /> },
      { path: '/signup', element: <SignupPage /> },
      { path: '/invite/:token', element: <InvitePage /> },
      { path: '/reset-password/:token', element: <ResetPasswordPage /> },
      { path: '/join/:token', lazy: () => import('./session/guest-join-page').then((m) => ({ Component: m.GuestJoinPage })) },
      {
        path: '/studios/:studioId/live',
        lazy: () => import('./session/member-join-page').then((m) => ({ Component: m.MemberJoinPage })),
      },
      {
        path: '/recordings/:recordingId/edit',
        lazy: () => import('./editor/editor-page').then((m) => ({ Component: m.EditorPage })),
      },
      {
        element: (
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        ),
        children: [
          { path: '/', element: <Navigate to="/studios" replace /> },
          { path: '/studios', element: <StudiosPage /> },
          { path: '/studios/:studioId', element: <StudioPage /> },
          { path: '/recordings', element: <RecordingsPage /> },
          { path: '/recordings/import', element: <ImportPage /> },
          { path: '/recordings/:recordingId', element: <RecordingPage /> },
          { path: '/team', element: <TeamPage /> },
          { path: '*', element: <NotFoundPage /> },
        ],
      },
    ],
  },
])
